{
  "title": "Refunds",
  "subtitle": "Customer credit paid back from a cash or bank account.",
  "new": "Refund credit",
  "newTitle": "Refund customer credit",
  "newSubtitle": "Pays the customer back and posts to the books straight away. The number is assigned when you save.",
  "kind": "Refund",
  "save": "Record refund",
  "searchLabel": "Search refunds",
  "searchPlaceholder": "Search number, reference or customer…",
  "chooseAccount": "Choose the cash or bank account",
  "chooseCustomerFirst": "Choose the customer to see their unapplied credit.",
  "voidTitle": "This refund is void",
  "sections": {
    "refund": "Refund",
    "credits": "Unapplied credit",
    "applications": "Credit refunded",
    "payment": "Payment"
  },
  "fields": {
    "date": "Refund date",
    "account": "Paid from",
    "method": "Method",
    "amount": "Amount refunded",
    "recordedAt": "Recorded",
    "source": "Credit",
    "sourceDate": "Date",
    "available": "Unapplied",
    "refundAmount": "Refund",
    "total": "Total refund",
    "from": "From"
  },
  "source": {
    "RECEIPT": "Receipt",
    "CREDIT_NOTE": "Credit note"
  },
  "hints": {
    "reference": "Cheque or transfer number.",
    "credits": "The customer's receipts and credit notes with unapplied credit. Refund all or part of each.",
    "noAccounts": "No active cash or bank account. Ask an administrator to add one under Accounting › Cash & bank."
  },
  "credits": {
    "tableLabel": "Unapplied credit",
    "refundAll": "Refund all",
    "clear": "Clear amounts",
    "none": "This customer has no unapplied credit.",
    "noneBody": "Credit appears here when a receipt or credit note is not fully applied to invoices.",
    "limited": "Showing only the {{n}} newest documents with unapplied credit.",
    "overAvailable": "More than is left on this credit.",
    "afterRefund": "Dated after the refund. Change the refund date.",
    "amountOf": "Amount to refund from {{number}}",
    "summary": "{{amount}} is paid back to the customer."
  },
  "errors": {
    "noCredit": "Enter an amount to refund on at least one receipt or credit note.",
    "overAvailable": "An amount is more than is left on its credit. Lower it.",
    "afterRefund": "A credit is dated after the refund. Change the refund date, or leave that credit out.",
    "REFUND_EXCEEDS_CREDIT": "An amount is more than is left to refund on its credit.",
    "WALK_IN_NO_CREDIT": "The walk-in customer keeps no credit, so this refund can't be voided on its own."
  },
  "actions": {
    "refund": "Refund credit",
    "void": "Void refund"
  },
  "void": {
    "title": "Void {{number}}?",
    "body": "The credit goes back to the receipts and credit notes it came from, and the journal entry is reversed. The refund stays on record, marked void."
  },
  "toast": {
    "created": "Refund {{number}} recorded",
    "voided": "{{number}} voided"
  },
  "empty": {
    "title": "No refunds yet.",
    "body": "Pay a customer back the credit left on their receipts and credit notes.",
    "void": "No void refunds."
  },
  "tillDocument": {
    "title": "Made at the till",
    "body": "This refund was paid out at the till for a return, so it can't be voided here."
  },
  "views": {
    "label": "Refund views",
    "all": "All",
    "void": "Void",
    "paidOut": "Paid out"
  },
  "stats": {
    "label": "Refund figures",
    "paidOut": "Paid out",
    "credit": "Credit to refund",
    "creditDetail": "{{receipts}} · {{notes}}",
    "creditAll": "All customers",
    "unavailable": "Figures unavailable",
    "void": "Void",
    "voidDetail": "Cancelled, the credit given back",
    "refunds_one": "{{n}} refund",
    "refunds_other": "{{n}} refunds",
    "receipts_one": "{{n}} receipt",
    "receipts_other": "{{n}} receipts",
    "notes_one": "{{n}} credit note",
    "notes_other": "{{n}} credit notes"
  }
}
